import React from 'react';
import { Box, Typography } from '@mui/material';
import { EventCreationForm } from '../../components/domain/event';

/**
 * Step 3: Create Event
 * Uses the reusable EventCreationForm (same functionality as Events page).
 */
const CreateEvent = ({ selectedResource, registerSubmit, onCanSubmitChange }) => {
  const resourceId = selectedResource?.id || null;

  if (!resourceId) {
    return (
      <Box sx={{ mt: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Please select a resource first.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 1 }}>
      <EventCreationForm
        resourceId={resourceId}
        registerSubmit={registerSubmit}
        onCanSubmitChange={onCanSubmitChange}
        showActions={false}
      />
    </Box>
  );
};

export default CreateEvent;
